import { render, staticRenderFns } from "./IconCpu.vue?vue&type=template&id=2be24fcc&scoped=true&"
var script = {}
import style0 from "./IconCpu.vue?vue&type=style&index=0&id=2be24fcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be24fcc",
  null
  
)

export default component.exports